<template>
  <div class="plan-list">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      addText=""
      :disablePage='disablePage'
      :count='count'
      :current="page"
    >
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem" v-if="roleType!==2">
            <label>门店名称:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <label>创建时间:</label>
            <timeStampDatePicker  v-model='query.createTime' class="item"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>记录类型:</label>
            <lk-select v-model='query.type' class="item">
              <lk-option v-for="(item, index) in recordType" :key="index" :value="index+2">{{item}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>养护状态:</label>
            <lk-select v-model='query.status' class="item">
              <lk-option v-for="(item, index) in maintainStatus" :key="index" :value="index+1">{{item}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>设备编码:</label>
            <lk-input clearable v-model='query.assertsCode' class="item"></lk-input>
          </div>
          <div class="queryItem">
            <label>设备名称:</label>
            <lk-input clearable v-model='query.assertsName' class="item"></lk-input>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-table
          border
          :columns='computedColumns'
          :data='tableData'
          ></lk-table>
      </div>
    </QueryFrame>

  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import assets from '../../services/assets';
import PlanExpand from './PlanExpand.vue';
import CommonPlanExpand from './CommonPlanExpand.vue';
import system from '../../services/system';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import utils from '../../libs/utils';

export default {
  name: 'plan',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
  },
  data() {
    return {
      storeList: [],
      showAdd: false,
      showEdit: false,
      query: {
        storeIdList: [],
        createTime: null,
        type: '',
        status: '',
        assertsName: '',
        assertsCode: '',
      },
      recordType: ['养护', '检定'],
      maintainStatus: ['进行中', '已完成'],
      tableData: [],
      disablePage: false,
      selection: [],
      status: ['在用', '停用', '封存', '报废'],
    };
  },
  methods: {
    jumpToInput(row) {
      const { type } = row;
      if (type == 3) {
        // 复杂
        this.$router.push({
          name: 'maintainPlanMeasure',
          query: { id: row.id },
        });
      } else if (type == 2) {
        // 简单
        this.$router.push({
          name: 'maintainPlanCommon',
          query: { id: row.id },
        });
      }
    },
    clear() {
      this.query = {
        storeId: [],
        createTime: null,
        type: '',
        status: '',
        assertsName: '',
        assertsCode: '',
      };
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      // if (this.params.createTime) {
      //   // this.params.createTime = utils.exchangeDate(this.params.createTime);
      //   this.params.createTime = (new Date(this.params.createTime)).getTime();
      // }
      assets.planList(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = { ...item.assertsCuringPlan };
            result.assertsCuringHistoryVOs = item.assertsCuringHistoryVOs;
            result.assertsLength = item.assertsCuringHistoryVOs.length;
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    // handleSearch() {
    //   this.query = Object.assign({}, this.query);
    //   this.handlePage(1, true);
    // },
    // handlePage(page, isSearch) {
    //   this.page = page;
    //   if (isSearch) {
    //     this.disablePage = true;
    //     this.$nextTick(() => {
    //       this.disablePage = false;
    //       this.size = 10;
    //       this.getData();
    //     });
    //   } else {
    //     this.getData();
    //   }
    // },
    // handlePageSize(size) {
    //   this.size = size;
    //   this.getData();
    // },
    addNew() {
      // this.$router.push({ name: 'planAdd' });
    },
    getStroeList() {
      system.getBelongStores().then((res) => {
        if (res.data.status === 200) {
          this.storeList = res.data.data;
        }
      });
    },
  },
  computed: {
    isGeneral() {
      const currentRoleIds = [];
      this.$store.state.user.roles.forEach((item) => {
        currentRoleIds.push(item.type);
      });
      if (currentRoleIds.includes(1)) { // 门店管理员
        return true;
      }
      return false;
    },
    computedColumns() {
      if (this.roleType !== 2) {
        return [
          {
            type: 'expand',
            width: 46,
            render: (h, { row }) => {
              let rowComponent = CommonPlanExpand;
              if (row.type == 3) {
                rowComponent = PlanExpand;
              }
              return h(rowComponent,
                {
                  props: {
                    row,
                  },
                });
            },
          },
          {
            title: '门店名称',
            key: 'storeName',
            minWidth: 116,
          },
          {
            title: '记录类型',
            key: 'typeStr',
            minWidth: 116,
          },
          {
            title: '记录编码',
            key: 'code',
            minWidth: 116,
          },
          {
            title: '养护状态',
            key: 'statusStr',
            minWidth: 116,
          },
          {
            title: '创建人',
            key: 'createUserName',
            minWidth: 116,
          },
          {
            title: '设备数量',
            minWidth: 116,
            key: 'assertsLength',
          },
          {
            title: '操作',
            minWidth: 116,
            render: (h, { row }) => {
              const buttonText = row.status == 1 ? '录入' : '打印';
              return this.handlePermission('maintainPlanCommon') ? h('lk-button',
                {
                  props: {
                    type: 'text',
                  },
                  on: {
                    click: () => {
                      this.jumpToInput(row);
                    },
                  },
                },
                buttonText) : null;
            },
          },
        ];
      }
      return [
        {
          type: 'expand',
          width: 46,
          render: (h, { row }) => {
            let rowComponent = CommonPlanExpand;
            if (row.type == 3) {
              rowComponent = PlanExpand;
            }
            return h(rowComponent,
              {
                props: {
                  row,
                },
              });
          },
        },
        {
          title: '记录类型',
          key: 'typeStr',
          minWidth: 116,
        },
        {
          title: '记录编码',
          key: 'code',
          minWidth: 116,
        },
        {
          title: '养护状态',
          key: 'statusStr',
          minWidth: 116,
        },
        {
          title: '创建人',
          key: 'createUserName',
          minWidth: 116,
        },
        {
          title: '设备数量',
          minWidth: 116,
          key: 'assertsLength',
        },
        {
          title: '操作',
          minWidth: 116,
          render: (h, { row }) => {
            const buttonText = row.status == 1 ? '录入' : '打印';
            const disabled = row.status != 1;
            return this.handlePermission('maintainPlanCommon') ? h('lk-button',
              {
                props: {
                  type: 'text',
                  disabled,
                },
                on: {
                  click: () => {
                    this.jumpToInput(row);
                  },
                },
              },
              buttonText) : null;
          },
        },
      ];
    },
  },
  mounted() {
    this.handleSearch(true);
  },
  created() {
    // this.getData();
    this.getStroeList();
  },
};
</script>
<style lang="less" scoped>
.plan-list{
  .query-item{
    display: flex;
    align-items: center;
    .query-label{
      margin-right: 10px;
    }
  }
  .search-btn{
    margin-right: 10px;
  }
  .query-params-wrap{
    padding-bottom: 20px;
  }
}
</style>
